var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Interessado" } }),
      _c(
        "div",
        { staticClass: "pad5" },
        [
          _vm.interessado.espolio !== null && !_vm.isProcessoFisico
            ? _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("É espólio?")]),
                _c("span", [_vm._v("  " + _vm._s(_vm.isEspolio))])
              ])
            : _vm._e(),
          _vm.interessado.pessoa.tipo === "PF"
            ? _c(
                "div",
                [
                  _c("app-resumo-pessoa-fisica", {
                    attrs: {
                      pessoa: _vm.interessado.pessoa.pessoaFisica,
                      isCadastro: true
                    }
                  }),
                  _c(
                    "el-row",
                    { staticClass: "labelDiv" },
                    [
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Tipo de documento:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaFisica
                                          .tipoDocumento
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.interessado.pessoa.pessoaFisica.tipoDocumento ==
                      "OUTROS"
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Outros:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaFisica
                                          .outrosTipoDocumento
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      !_vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Email:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " + _vm._s(_vm.interessado.pessoa.email)
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isLiberacao
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Profissão:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.interessado.pessoa.pessoaFisica
                                        .profissao
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Estado civil:")
                          ]),
                          _c("span", [
                            _vm._v(
                              "  " +
                                _vm._s(
                                  _vm.getEstadoCivil(
                                    _vm.interessado.pessoa.pessoaFisica
                                      .estadoCivil
                                  )
                                )
                            )
                          ])
                        ])
                      ]),
                      _c(
                        "el-col",
                        { staticClass: "labelTel", attrs: { span: 12 } },
                        [
                          _c(
                            "p",
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Telefone(s):")
                              ]),
                              _vm.interessado.pessoa.telefones &&
                              !_vm.interessado.pessoa.telefones.length
                                ? _c("span", [_vm._v("  " + _vm._s("-"))])
                                : _vm._e(),
                              _vm._l(_vm.interessado.pessoa.telefones, function(
                                item
                              ) {
                                return _c("span", [_vm._v("  " + _vm._s(item))])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("CNPJ:")
                          ]),
                          _c("span", [
                            _vm._v(
                              "  " +
                                _vm._s(
                                  _vm.filterNull(
                                    _vm.interessado.pessoa.pessoaJuridica.cnpj
                                  )
                                )
                            )
                          ])
                        ])
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Razão Social:")
                          ]),
                          _c("span", [
                            _vm._v(
                              "  " +
                                _vm._s(
                                  _vm.filterNull(
                                    _vm.interessado.pessoa.pessoaJuridica
                                      .razaoSocial
                                  )
                                )
                            )
                          ])
                        ])
                      ]),
                      !_vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "p",
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Telefone(s):")
                                ]),
                                _vm._l(
                                  _vm.interessado.pessoa.telefones,
                                  function(item) {
                                    return _c("span", [
                                      _vm._v("  " + _vm._s(item))
                                    ])
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      !_vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("E-mail:")
                              ]),
                              _c("span", [
                                _vm._v("  " + _vm._s(_vm.getEmail()))
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(
                                  "Nome do presidente da associação/empresa:"
                                )
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao.nome
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("CPF:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao.cpf
                                      )
                                    ) +
                                    ","
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("RG:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao.rg
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("UF do RG:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.getUfRg(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao
                                      ) || "-"
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Tipo de documento:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao.tipoDocumento
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.interessado.pessoa.pessoaJuridica.presidenteAssociacao
                        .tipoDocumento == "OUTROS"
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Outros:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao
                                          .outrosTipoDocumento
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Órgão expedidor:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.getOrgaoExpedidor(
                                        _vm.interessado.pessoa.pessoaJuridica
                                          .presidenteAssociacao.orgaoExpedidor
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
          _c("p"),
          !_vm.isProcessoFisico
            ? _c("app-resumo-endereco", {
                attrs: { endereco: _vm.interessado.pessoa.endereco }
              })
            : _vm._e(),
          _c("br"),
          _vm.hasConjuge
            ? _c("div", [
                _vm.isCasado
                  ? _c(
                      "div",
                      [
                        _c("app-divider", {
                          attrs: { label: "Dados do cônjuge" }
                        }),
                        _c("app-resumo-pessoa-fisica", {
                          staticClass: "pad5",
                          attrs: {
                            pessoa: _vm.interessado.conjuge.pessoaFisica,
                            isCadastro: true,
                            isProcessoFisicoConjuge: true
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isViuvo && !_vm.isProcessoFisico
                  ? _c(
                      "div",
                      [
                        _c("app-divider", {
                          attrs: { label: "Dados do cônjuge" }
                        }),
                        _c("div", { staticClass: "pad5" }, [
                          _c("p", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("CPF:")
                            ]),
                            _c("span", [
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    _vm.filterNull(
                                      _vm.interessado.conjuge.pessoaFisica.cpf
                                    )
                                  )
                              )
                            ])
                          ]),
                          _c("p", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("Nome:")
                            ]),
                            _c("span", [
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    _vm.filterNull(
                                      _vm.interessado.conjuge.pessoaFisica.nome
                                    )
                                  )
                              )
                            ])
                          ]),
                          _c("p", [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("Possui certidão de óbito?")
                            ]),
                            _c("span", [_vm._v("  " + _vm._s(_vm.hasCertidao))])
                          ])
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm.hasSocios
            ? _c(
                "div",
                [
                  _c("app-divider", { attrs: { label: "Sócios" } }),
                  _c("app-resumo-socios", {
                    attrs: { socios: _vm.interessado.socios }
                  }),
                  _c("br")
                ],
                1
              )
            : _vm._e(),
          _c("app-resumo-documentos", {
            attrs: {
              documentos: _vm.interessado.documentos,
              codigoCadastro: "interessado",
              idCadastro: _vm.idCadastro,
              isProcessoFisico: true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e207ba3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e207ba3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoInteressado.vue
// module id = null
// module chunks = 